var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstantTransferRouteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F0AD4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3575 22.1782H21.4009V23.0389H17.2233V25.25L13.8615 21.9078L13.25 21.2984L17.138 17.4316V19.5711H18.2846V20.4304H16.2722V19.5083L14.473 21.2984L16.2222 23.0389L16.3575 23.1734V22.1782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7498 18.7016L26.1383 19.311L22.8603 22.5684V20.4289C21.6255 20.4289 20.3907 20.4289 19.1545 20.4304V19.5711C20.6789 19.5696 22.2017 19.5696 23.7261 19.5696V20.4917L25.5268 18.7016L23.6408 16.8266V17.8233H18.5974V16.9625H22.775V14.75L26.7498 18.7016Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantTransferRouteIcon);
export default __webpack_public_path__ + "static/media/instant-transfer-route-icon.078be7b66952245971579e0f3293fbe6.svg";
export { ForwardRef as ReactComponent };